<template>

<section class="container my-2">

<div class="board shadow">

  <h3>Buttons</h3>
  <p class="display-8">Use SymCSS custom button styles for actions in forms, dialogs, and more with support for multiple sizes, states, and more.</p>
  <br><hr>

  <p class='bold'>● Button elements (no container) - rendered inline and no margins by default</p>

  <div class="box-border">
    <button class="info">info</button>
    <button class="success">success</button>
    <button class="warning">warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
    <button class="info-light">info-light</button>
    <button class="success-light">success-light</button>
    <button class="warning-light">warning-light</button>
    <button class="danger-light">danger-light</button>
    <button class="primary-light">primary-light</button>
    <button class="dark-light">dark-light</button>

    <br><br>

    <button class="success"><i class="fa fa-lg fa-check mr-2"></i>success</button>
    <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="19">
  <button class="info">info</button>
  <button class="success">success</button>
  <button class="warning">warning</button>
  <button class="danger">danger</button>
  <button class="primary">primary</button>
  <button class="dark">dark</button>
  <button class="info-light">info-light</button>
  <button class="success-light">success-light</button>
  <button class="warning-light">warning-light</button>
  <button class="danger-light">danger-light</button>
  <button class="primary-light">primary-light</button>
  <button class="dark-light">dark-light</button>

  <br><br>

  <button class="success"><i class="fa fa-lg fa-check mr-2"></i>success</button>
  <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons (no container) - with custom style, rendered inline by default</p>

  <div class="box-border">
    <button class="info curved-left-2 border-dark">Back</button>
    <button class="info curved-0 border-dark border-left-0 border-right-0">Details</button>
    <button class="info curved-right-2 border-dark">Next</button>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="5">
  <button class="info curved-left-2 border-dark">Back</button>
  <button class="info curved-0 border-dark border-left-0 border-right-0">Details</button>
  <button class="info curved-right-2 border-dark">Next</button>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons (inside 'buttons' container) - rendered inline by default; with built-in margins</p>

  <div class="box-border pb-1">
    <div class="buttons">
      <button class="info">info</button>
      <button class="success">success</button>
      <button class="warning">warning</button>
      <button class="danger">danger</button>
      <button class="primary">primary</button>
      <button class="dark">dark</button>
      <button class="info-light">info-light</button>
      <button class="success-light">success-light</button>
      <button class="warning-light">warning-light</button>
      <button class="danger-light">danger-light</button>
      <button class="primary-light">primary-light</button>
      <button class="dark-light">dark-light</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="16">
  <div class="buttons">
    <button class="info">info</button>
    <button class="success">success</button>
    <button class="warning">warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
    <button class="info-light">info-light</button>
    <button class="success-light">success-light</button>
    <button class="warning-light">warning-light</button>
    <button class="danger-light">danger-light</button>
    <button class="primary-light">primary-light</button>
    <button class="dark-light">dark-light</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - with icon font (FontAwesome) on the left/right, with or without caption</p>

  <div class="box-border pb-1">
    <div class="buttons mr-4" info>
      <button><i class="fa fa-lg fa-chevron-left mr-2"></i>Back</button>
      <button>Details</button>
      <button>Next<i class="fa fa-lg fa-chevron-right ml-2"></i></button>
    </div>

    <div class="buttons" info>
      <button class="d-block"><i class="fa fa-lg fa-fw fa-chevron-left"></i></button>
      <button class="d-block"><i class="fa fa-lg fa-fw fa-file-text-o"></i></button>
      <button class="d-block"><i class="fa fa-lg fa-fw fa-chevron-right"></i></button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="13">
    <div class="buttons mr-4" info>
      <button><i class="fa fa-lg fa-chevron-left mr-2"></i>Back</button>
      <button>Details</button>
      <button>Next<i class="fa fa-lg fa-chevron-right ml-2"></i></button>
    </div>

  <div class="buttons" info>
    <button class="d-block"><i class="fa fa-lg fa-fw fa-chevron-left"></i></button>
    <button class="d-block"><i class="fa fa-lg fa-fw fa-file-text-o"></i></button>
    <button class="d-block"><i class="fa fa-lg fa-fw fa-chevron-right"></i></button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Button elements (inside 'buttons' container) - rendered inline by default; fixed-width and right-aligned text; buttons with icon individually styled</p>

  <div class="box-border pb-1">
    <div class="buttons" fw-33 text-right>
      <button class="info">info</button>
      <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
      <button class="warning justify-between"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
      <button class="danger">danger</button>
      <button class="primary">primary</button>
      <button class="dark">dark</button>
      <button class="info-light">info-light</button>
      <button class="success-light">success-light</button>
      <button class="warning-light">warning-light</button>
      <button class="danger-light">danger-light</button>
      <button class="primary-light">primary-light</button>
      <button class="dark-light">dark-light</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="16">
  <div class="buttons" fw-33 text-right>
    <button class="info">info</button>
    <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
    <button class="warning justify-between"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
    <button class="info-light">info-light</button>
    <button class="success-light">success-light</button>
    <button class="warning-light">warning-light</button>
    <button class="danger-light">danger-light</button>
    <button class="primary-light">primary-light</button>
    <button class="dark-light">dark-light</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Full-width Button - spans the full width of the parent element; set via attribute 'w-100' at container level or per button as class 'w-100'</p>

  <div class="box-border pb-1">
    <div class="buttons" w-100>
      <button class="info">This is a full-width button - info</button>
      <button class="success">This is a full-width button - success</button>
      <button class="warning">This is a full-width button - warning</button>
      <button class="danger">This is a full-width button - danger</button>
      <button class="primary">This is a full-width button - primary</button>
      <button class="dark">This is a full-width button - dark</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="10">
  <div class="buttons" w-100>
    <button class="info">This is a full-width button - info</button>
    <button class="success">This is a full-width button - success</button>
    <button class="warning">This is a full-width button - warning</button>
    <button class="danger">This is a full-width button - danger</button>
    <button class="primary">This is a full-width button - primary</button>
    <button class="dark">This is a full-width button - dark</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Outline Buttons - just shows outline, no background color except on hover; attribute 'outline' set at container level</p>

  <div class="box-border pb-1">
    <div class="buttons" outline>
      <button class="info">info</button>
      <button class="success">success</button>
      <button class="warning">warning</button>
      <button class="danger">danger</button>
      <button class="primary">primary</button>
      <button class="dark">dark</button>
      <button class="info-light">info-light</button>
      <button class="success-light">success-light</button>
      <button class="warning-light">warning-light</button>
      <button class="danger-light">danger-light</button>
      <button class="primary-light">primary-light</button>
      <button class="dark-light">dark-light</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="16">
  <div class="buttons" outline>
    <button class="info">info</button>
    <button class="success">success</button>
    <button class="warning">warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
    <button class="info-light">info-light</button>
    <button class="success-light">success-light</button>
    <button class="warning-light">warning-light</button>
    <button class="danger-light">danger-light</button>
    <button class="primary-light">primary-light</button>
    <button class="dark-light">dark-light</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Button Sizes - font and icon sizes adjust automatically; buttons styled invividually via classes 'lg-1', 'lg-2', 'lg-3', 'sm-1', 'sm-2', 'sm-3'</p>

  <div class="box-border pb-1">
    <div class="buttons d-inline" success>
      <button><i class="fa fa-gear mr-2"></i>Standard</button>
      <button class="lg-1"><i class="fa fa-gear mr-2"></i>Large-1</button>
      <button class="lg-2"><i class="fa fa-gear mr-2"></i>Large-2</button>
      <button class="lg-3 mr-5"><i class="fa fa-gear mr-2"></i>Large-3</button>
      <button><i class="fa fa-gear mr-2"></i>Standard</button>
      <button class="sm-1"><i class="fa fa-gear mr-2"></i>Small-1</button>
      <button class="sm-2"><i class="fa fa-gear mr-2"></i>Small-2</button>
      <button class="sm-3"><i class="fa fa-gear mr-2"></i>Small-3</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="12">
  <div class="buttons d-inline" success>
    <button><i class="fa fa-gear mr-2"></i>Standard</button>
    <button class="lg-1"><i class="fa fa-gear mr-2"></i>Large-1</button>
    <button class="lg-2"><i class="fa fa-gear mr-2"></i>Large-2</button>
    <button class="lg-3 mr-5"><i class="fa fa-gear mr-2"></i>Large-3</button>
    <button><i class="fa fa-gear mr-2"></i>Standard</button>
    <button class="sm-1"><i class="fa fa-gear mr-2"></i>Small-1</button>
    <button class="sm-2"><i class="fa fa-gear mr-2"></i>Small-2</button>
    <button class="sm-3"><i class="fa fa-gear mr-2"></i>Small-3</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - uniform size ( 'lg-3' - Large 3 ) and width ('fw-36'); set once at container level as attributes</p>

  <div class="box-border pb-1">
    <div class="buttons" lg-3 fw-36>
      <button class="info">info</button>
      <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
      <button class="warning justify-between"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
      <button class="danger">danger</button>
      <button class="primary">primary</button>
      <button class="dark">dark</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="10">
  <div class="buttons" lg-3 fw-36>
    <button class="info">info</button>
    <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
    <button class="warning justify-between"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Disabled Button - set via attribute 'disabled'</p>

  <div class="box-border pb-1">
    <div class="buttons">
      <button class="info">Enabled</button>
      <button class="info" disabled>Disabled</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="6">
  <div class="buttons">
    <button class="info">Enabled</button>
    <button class="info" disabled>Disabled</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Links as Buttons</p>

  <div class="box-border pb-1">
    <div class="buttons">
      <sym-link class='button info' to="samples-container" >Go to Section 01 &raquo;</sym-link>
      <sym-link class='button warning outline' to="samples-card" >Go to Section 02 &raquo;</sym-link>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="6">
  <div class="buttons">
    <sym-link class='button info' to="#s01" >Go to Section 01 &raquo;</sym-link>
    <sym-link class='button warning outline' to="#s02" >Go to Section 02 &raquo;</sym-link>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - uniform color scheme, all with shadow; set once at container level as attributes 'warning' and 'shadow'</p>

  <div class="box-border pb-1">
    <div class="buttons" warning shadow>
      <button>Home</button>
      <button>Contact</button>
      <button>About</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="7">
  <div class="buttons" warning shadow>
    <button>Home</button>
    <button>Contact</button>
    <button>About</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - vertical layout, using 'vertical' attribute, with button text right-aligned via attribute 'text-right'</p>

  <div class="box-border pb-1">
    <div class="buttons" vertical text-right>
      <button class="info">info</button>
      <button class="success"><i class="fa fa-lg fa-check mr-2"></i>success</button>
      <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
      <button class="danger">danger</button>
      <button class="primary">primary</button>
      <button class="dark">dark</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="10">
  <div class="buttons" vertical text-right>
    <button class="info">info</button>
    <button class="success"><i class="fa fa-lg fa-check mr-2"></i>success</button>
    <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - sharp corners using attribute 'curved-0' at container level</p>

  <div class="box-border pb-1">
    <div class="buttons" curved-0>
      <button class="info">info</button>
      <button class="success"><i class="fa fa-lg fa-check mr-2"></i>success</button>
      <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
      <button class="danger">danger</button>
      <button class="primary">primary</button>
      <button class="dark">dark</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="10">
  <div class="buttons" curved-0>
    <button class="info">info</button>
    <button class="success"><i class="fa fa-lg fa-check mr-2"></i>success</button>
    <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - super-round corners using attribute 'curved-2', with button text right-aligned, uniform width (via attribute 'fw-33'). Note the use of class 'justify-between'; without it the icon appears adjacent to the text as in the case of 'warning' button</p>

  <div class="box-border pb-1">
    <div class="buttons" curved-2 text-right fw-33>
      <button class="info">info</button>
      <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
      <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
      <button class="danger">danger</button>
      <button class="primary">primary</button>
      <button class="dark">dark</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="10">
  <div class="buttons" curved-2 text-right fw-33>
    <button class="info">info</button>
    <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
    <button class="warning"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - justified (buttons having equal width via attribute 'justify'); width of 'buttons' container is ditributed equally among contained buttons. Long captions wrap vertically to maintain uniform width.</p>

  <div class="box-border pb-1">
    <div class="buttons fw-70" justify>
      <button class="success">success</button>
      <button class="primary">button with a long caption</button>
      <button class="dark">dark</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="7">
    <div class="buttons fw-70" justify>
      <button class="success">success</button>
      <button class="primary">button with a long caption</button>
      <button class="dark">dark</button>
    </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - filled (proportionately adjust button widths to fill all available space via attribute 'fill'); 'buttons' container takes up entire width of parent element. Notice that all horizontal space is occupied, but not every button has the same width.</p>

  <div class="box-border pb-1">
    <div class="buttons" fill>
      <button class="info">info</button>
      <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
      <button class="warning justify-between"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
      <button class="danger">danger</button>
      <button class="primary">button with a long caption</button>
      <button class="dark">dark</button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="10">
  <div class="buttons" fill>
    <button class="info">info</button>
    <button class="success justify-between"><i class="fa fa-lg fa-check mr-2"></i>success</button>
    <button class="warning justify-between"><i class="fa fa-lg fa-warning mr-2"></i>warning</button>
    <button class="danger">danger</button>
    <button class="primary">primary</button>
    <button class="dark">dark</button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons - compact (no spaces separating the buttons), attribute 'compact' set at 'buttons' container level</p>

  <div class="box-border pb-1">
    <div class="buttons" compact info>
      <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
      <button><i class="fa fa-file-text-o mr-2"></i>Details</button>
      <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="7">
  <div class="buttons" compact info>
    <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
    <button><i class="fa fa-file-text-o mr-2"></i>Details</button>
    <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons inside toolbar - div element (with class 'toolbar') hosting 'buttons' container with 'compact' attribute plus textbox with search button  </p>

  <div class="toolbar" success-light>
    <div class="buttons mr-2" compact info>
      <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
      <button><i class="fa fa-file-text-o mr-2"></i>Details</button>
      <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
    </div>

    <sym-text class="d-inline" v-model="guestName" caption="Search" :caption-width="16" :input-width="44" icon="search"></sym-text>

  </div>

  <br><br>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="12">
  <div class="toolbar" success-light>
    <div class="buttons mr-2" compact info>
      <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
      <button><i class="fa fa-file-text-o mr-2"></i>Details</button>
      <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
    </div>

    <sym-text class="d-inline" v-model="guestName" caption="Search" :caption-width="24" :input-width="64" icon="search"></sym-text>

  </div>
  </textarea>

  <br><hr>

  <p class='bold'>● Buttons container alignment - Left aligned by default; centered (via class 'text-center') or right-aligned (via class 'text-right') at 'buttons' container level</p>

  <div class="box-border pb-1">
    <div class="buttons" warning>
      <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
      <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
    </div>

    <div class="buttons d-block text-center " info>
      <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
      <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
    </div>

    <div class="buttons d-block text-right" info-light>
      <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
      <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="16">
  <div class="buttons" warning>
    <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
    <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
  </div>

  <div class="buttons d-block text-center" info>
    <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
    <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
  </div>

  <div class="buttons d-block text-right" info-light>
    <button><i class="fa fa-chevron-left mr-2"></i>Back</button>
    <button>Next<i class="fa fa-chevron-right ml-2"></i></button>
  </div>
  </textarea>

</div>

</section>

</template>

<script>

import PageBase from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'samples-button',

  data () {
    return {
      guestName: ''
    };
  }
}

</script>
